import { render, staticRenderFns } from "./HistoryPlane.vue?vue&type=template&id=4f2acd08&scoped=true"
import script from "./HistoryPlane.vue?vue&type=script&lang=js"
export * from "./HistoryPlane.vue?vue&type=script&lang=js"
import style0 from "./HistoryPlane.vue?vue&type=style&index=0&id=4f2acd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2acd08",
  null
  
)

export default component.exports